/**
 * @ref https://www.npmjs.com/package/vue-cookies
 */

import Vue from 'vue';
Vue.use(require('vue-cookies'));